<div class="ov-subbar" *ngIf="selectedTask">
  <div class="ov-subbar-left">
    <span class="freq-badge">{{ getAuditFrequencyLabel() }}</span>
    <span class="period-date" *ngIf="periodMain">{{ periodMain }}</span>
    <span class="period-compare" *ngIf="periodCompare">{{ periodCompare }}</span>
  </div>
  <div class="ov-subbar-right">
    <span class="bench-label" *ngIf="competitors.length">Benchmarking against</span>
    <button
      *ngFor="let comp of competitors"
      class="comp-chip"
      [class.active]="isActiveCompetitor(comp)"
      (click)="selectCompetitor(comp)"
    >
      {{ getCompChipLabel(comp) }}
    </button>
    <button
      class="comp-chip comp-chip--add"
      *ngIf="selectedTask?.type !== 'Crawler' && !isShare"
      (click)="addCompetitor()"
    >
      + Add competitor
    </button>
  </div>
</div>
